export default __webpack_public_path__ + "static/media/LogoInicio.4ba3d74d.svg";